import React from 'react'
import { Accordion, AccordionSummary, AccordionDetails, Typography, TextField, FormHelperText, Grid, Box } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CommonQuillEditor from 'common/editor';

function TopSection({
    topSectionOpen,
    setTopSectionOpen,
    formData,
    setFormData,
    errors,
    setErrors,
}){
  return <Accordion expanded={topSectionOpen} onChange={() => setTopSectionOpen(!topSectionOpen)}>
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      aria-controls="paneltopsection-content"
      id="paneltopsection-header"
    >
      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="h4" fontWeight="semibold" style={{ color: "#2E2E3A" }}>
          Top Section
        </Typography>
      </Box>
    </AccordionSummary>
    <AccordionDetails>
      <Grid container direction="row" spacing={3}>
        <Grid item xs={12} md={6}>
          <Typography
            variant="body2"
            fontWeight="medium"
            color="#9A9AAF"
            mb={1}
            style={{ fontSize: "14px" }}
          >
            Heading (H1)
          </Typography>
          <TextField
            label=""
            className="form-input"
            fullWidth
            name="topSectionPageTitle"
            error={errors.topSectionPageTitle}
            helperText={errors.topSectionPageTitle}
            placeholder=""
            value={formData.topSection?.pageTitle || ""}
            onChange={(e) => {
              const pageTitle = e.target.value;
              setFormData((prev) => ({
                ...prev,
                topSection: {
                  ...prev.topSection,
                  pageTitle,
                },
              }));
              setErrors({
                ...errors,
                topSectionPageTitle: "",
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography
            variant="body2"
            fontWeight="medium"
            color="#9A9AAF"
            mb={1}
            style={{ fontSize: "14px" }}
          >
            Sub Heading(H2)
          </Typography>
          <TextField
            label=""
            className="form-input"
            fullWidth
            placeholder=""
            name="topSectionSubHeading"
            error={errors?.topSectionSubHeading}
            helperText={errors?.topSectionSubHeading}
            value={formData.topSection?.subHeading || ""}
            onChange={(e) => {
              const subHeading = e.target.value;
              setFormData((prev) => ({
                ...prev,
                topSection: {
                  ...prev.topSection,
                  subHeading,
                },
              }));
              setErrors({
                ...errors,
                topSectionSubHeading: "",
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography
            variant="body2"
            fontWeight="medium"
            color="#9A9AAF"
            mb={1}
            style={{ fontSize: "14px" }}
            name="topSectiontopDescription"
          >
            Top Description
          </Typography>
          <Box className="remove-quill-mb">
            <CommonQuillEditor
              allowHeading={false}
              value={formData.topSection?.topDescription || ""}
              onChange={(topDescription) => {
                setFormData((prev) => ({
                  ...prev,
                  topSection: {
                    ...prev.topSection,
                    topDescription,
                  },
                }));
                setErrors({
                  ...errors,
                  topSectiontopDescription: "",
                });
              }}
            />
            {Boolean(errors?.topSectiontopDescription) && (
              <FormHelperText error style={{ marginTop: "-20px" }}>
                {errors?.topSectiontopDescription}
              </FormHelperText>
            )}
          </Box>
        </Grid>
      </Grid>
    </AccordionDetails>
  </Accordion>
  
}

export default TopSection